import { createSelector } from 'reselect';

const selectNavigation = state => state.navigation

const selectIsOpen = createSelector(
    selectNavigation,
    navigation => navigation.open,
)

export { 
    selectIsOpen, 
}